import { Injectable } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCheck, faPlus, faStarOfLife, faFilter, faCircleStop, faArrowDownAZ, faSquarePlus, faMinus, faFloppyDisk, faRotateLeft, faLink, faSpinner, faMagnifyingGlass, faTimesCircle, faClock, faFile, faClose, faRightFromBracket, faCircleArrowLeft, faMagnifyingGlassPlus, faCircleCheck, faTrash, faDownload } from '@fortawesome/free-solid-svg-icons';

@Injectable({
  providedIn: 'root',
})
export class EmdmIcons {
  constructor(private famodule: FontAwesomeModule) {
  }

  public FaCheck = faCheck;
  public Facircle = faRotateLeft;
  public FacircleCheck = faCircleCheck;
  public facircleHollow = faCircleStop;
  public Fasearch = faMagnifyingGlass;
  public Faclose = faClose;
  public FaRightCheck = faRightFromBracket;
  public FaCircleArrowLeft = faCircleArrowLeft;
  public FaSearchPlus = faMagnifyingGlassPlus;
  public FaSpinner = faSpinner;
  public FaTimesClock = faTimesCircle;
  public FaClock = faClock;
  public FaFile = faFile;
  public FaFileDelete = faTrash;
  public FaPlus = faPlus;
  public FaSquarePlus = faSquarePlus;
  public FaMinus = faMinus;
  public FaStar = faStarOfLife;
  public Falink = faLink;
  public FaSave = faFloppyDisk;
  public FaSort = faArrowDownAZ;
  public faFilter = faFilter;
  public faClose = faClose;
  public faDownload = faDownload;
}